import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(
    private userService : UserService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    const user = await this.userService.getLocalUser();

    if (user && user.admin) {
      return true;
    } else {
      await this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
